import React, { useEffect, useState } from "react";
import TableImplementation from "../../Layouts/Table";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";
import DashboardCard from "../../Layouts/DashboardCard";
import Header from "../../Layouts/AppHeader/Header";
import {
  Typography,
  Breadcrumbs,
  Button,
  AppBar,
  Toolbar,
  Tooltip,
  IconButton,
  Menu,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router";
import { dashBoardFrontCardResponse } from "../../../@Types/DRO/HomePageResponse";
import { OrderOnDemandApi } from "../../../API/ZyppIt";
import DatePicker from "react-datepicker";
import { Logout } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import BlacklistedRidersTable from "../../Layouts/BlacklistedRidersTable";
import BanRidersModal from "../../Modals/BanRidersModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

function BlacklistedRiders() {
  return (
    <>
      <div className="flex">
        <div className="w-1/6 mr-3 ml-4">
          <SideBarNavigation />
        </div>
        <div className="w-5/6">
          <div className="pb-4 pr-4 pl-2 mt-6">
            <Header merchantLogoUrl="" />
            <div className="flex justify-between mt-8">
              <div className="font-medium text-left text-[32px] text-[#1E1E1E] font-inter">
                Blacklisted Riders
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  sx={{ mt: 4 }}
                >
                  <Typography
                    color="#717171"
                    sx={{ fontSize: "12px", fontWeight: "700" }}
                  >
                    Blacklisted Riders
                  </Typography>
                </Breadcrumbs>
              </div>
              <div className="flex">
                <div className="mt-1">
                  <BanRidersModal />
                </div>
                <div className="mt-1 ml-2">
                  <Button
                    variant="outlined"
                    sx={{
                      color: "#171F21",
                      textTransform: "none",
                      borderColor: "#171F21",
                      borderWidth: "2px",
                      borderRadius: "30px",
                      px: 3,
                      py: 1,
                      "&:hover": {
                        color: "#171F21",
                        borderColor: "#171F21",
                        borderWidth: "2px",
                        bgcolor: "transparent",
                      },
                    }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = `${process.env.PUBLIC_URL}/BulkBanRidersTemplate.csv`;
                      link.setAttribute(
                        "download",
                        "BulkBanRidersTemplate.csv"
                      );
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <FileDownloadOutlinedIcon
                      fontSize="small"
                      sx={{ color: "#171F21" }}
                    />
                    Download Template
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="ml-2 w-[98%]"
            style={{
              boxShadow: "0px 7px 29px 0px #64646F33",
              borderRadius: "8px",
            }}
          >
            <BlacklistedRidersTable />
          </div>
        </div>
      </div>
    </>
  );
}

export default BlacklistedRiders;
